import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import {
  Button,
  FormControl,
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { IconChalkboard, IconClipboard } from "@tabler/icons-react";

import ContainerLoading from "../components/ContainerLoading";
import ClassesRegister from "../components/ClassesRegister";
import CalendarComponent from "../components/CalendarComponent";
import ClassesCalendar from "../components/ClassesCalendar";
import ClassRegister from "../components/ClassRegister";
import PageHeader from "../components/PageHeader";

import { listClasses } from "../services/classes";
import { modalityList } from "../services/modality";

const Classes = () => {
  const [open, setOpen] = useState(false);
  const [openClassRegister, setOpenClassRegister] = useState(false);
  const [date, setDate] = useState(moment().toDate());
  const [modalities, setModalities] = useState("");

  // const {
  //   data: dataIndicators,
  //   isLoading: isLoadingIndicators,
  //   isFetching: isFetchingIndicators,
  //   refetch: refetchIndicators,
  // }: {
  //   data: {
  //     allClasses: number;
  //     classesByMonth: number;
  //     lessRegisteredClasses: { name: string; value: number };
  //     mostRegisteredClasses: { name: string; value: number };
  //   };
  //   isLoading: boolean;
  //   isFetching: boolean;
  //   refetch: () => void;
  // } = useQuery({
  //   queryKey: ["classesIndicators" + JSON.stringify(date)],
  //   queryFn: async () =>
  //     await classesIndicators({
  //       startDate: moment(date).startOf("month").toDate(),
  //       endDate: moment(date).endOf("month").toDate(),
  //     }),
  //   initialData: {
  //     allClasses: 0,
  //     classesByMonth: 0,
  //     lessRegisteredClasses: { name: "", value: 0 },
  //     mostRegisteredClasses: { name: "", value: 0 },
  //   },
  // });

  const {
    data: dataModality,
    isLoading: isLoadingModality,
    isFetching: isFetchingModality,
  }: {
    data: Array<{
      id: string;
      name: string;
      description: string;
      createdAt: string | Date;
      status: boolean;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["modalityList"],
    queryFn: async () => await modalityList({}),
    initialData: [],
  });

  const {
    data: dataclasses,
    isLoading: isLoadingClasses,
    isFetching: isFetchingClasses,
    refetch,
  }: {
    data: {
      classes: { id: string; date: Date }[];
      sessions: { id: string; date: Date }[];
    };
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: [
      "listClasses" + JSON.stringify(date) + JSON.stringify(modalities),
    ],
    queryFn: async () =>
      await listClasses({
        startDate: moment(date).startOf("month").toDate(),
        endDate: moment(date).endOf("month").toDate(),
        fightsId: modalities,
      }),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const dates = dataclasses?.classes?.map((i) => i.date);
  const uniqueSortedDates = [...new Set(dates)]
    .map((date) => moment(date))
    .sort((a: any, b: any) => a - b)
    .map((date) => date.toISOString());

  const loading =
    isLoadingModality ||
    isFetchingModality ||
    isLoadingClasses ||
    isFetchingClasses;

  return (
    <ContainerLoading loading={loading}>
      <PageHeader
        title="Aulas"
        subtitle="Informações gerais de aulas."
        padding={2}
        options={
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: { xs: "flex-start", lg: "flex-end" },
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{ gap: 0.5 }}
              onClick={() => setOpen(true)}
            >
              <IconChalkboard size={18} />
              <Typography variant="body2">Criar aula</Typography>
            </Button>
            <Button
              variant="contained"
              sx={{ gap: 0.5 }}
              onClick={() => setOpenClassRegister(true)}
            >
              <IconClipboard size={18} />
              <Typography variant="body2">Criar turma</Typography>
            </Button>
          </Stack>
        }
      />
      <Grid2 container spacing={2}>
        {/* <Grid2 size={12}>
          <IndicatorsCard
            data={[
              {
                id: 1,
                title: "Total aulas",
                value: dataIndicators?.allClasses,
                icon: "icon_chalkboard",
                size: { xs: 12, md: 6 },
              },
              {
                id: 2,
                title: "Aulas no mês",
                value: dataIndicators?.classesByMonth,
                icon: "icon_chalkboard",
                size: { xs: 12, md: 6 },
              },
            ]}
          />
        </Grid2> */}
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <Grid2 container spacing={2}>
            <Grid2
              size={{ xs: 12, md: 6, lg: 12 }}
              sx={{ borderRadius: 2, backgroundColor: "secondary.main" }}
            >
              <CalendarComponent
                date={date}
                markedDates={uniqueSortedDates}
                onChange={(e: any) => setDate(moment(e).toDate())}
                onMonthChange={(e: any) => setDate(moment(e).toDate())}
              />
            </Grid2>
            <Grid2
              size={{ xs: 12, md: 6, lg: 12 }}
              sx={{ borderRadius: 2, backgroundColor: "secondary.main" }}
            >
              <Stack>
                <Stack
                  sx={{
                    borderRadius: 2,
                    backgroundColor: "secondary.dark",
                    padding: 1,
                  }}
                >
                  <Typography fontWeight={600}>Modalidade</Typography>
                </Stack>
                <FormControl sx={{ padding: 2 }}>
                  <RadioGroup value={modalities}>
                    {dataModality.map((item) => (
                      <FormControlLabel
                        key={item.id}
                        value={item.id}
                        control={<Radio />}
                        label={item.name}
                        onClick={() =>
                          modalities === item.id
                            ? setModalities("")
                            : setModalities(item.id)
                        }
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Grid2>
            {/* <Grid2
              size={12}
              sx={{ borderRadius: 2, backgroundColor: "secondary.main" }}
            >
              <Stack spacing={2}>
                <Stack
                  sx={{
                    borderRadius: 2,
                    backgroundColor: "secondary.dark",
                    padding: 1,
                  }}
                >
                  <Typography fontWeight={600}>Tatame</Typography>
                </Stack>
                {dataSpaces?.map((item) => (
                  <Stack
                    key={item?.id}
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                      paddingX: 1.5,
                      paddingY: 1,
                    }}
                  >
                    <Circle
                      sx={{
                        color: "primary.main",
                        fontSize: 8,
                      }}
                    />
                    <Typography variant="body1" fontSize={12}>
                      {item?.name}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Grid2> */}
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 8 }}>
          <ClassesCalendar
            data={dataclasses}
            dateCalendar={date}
            refetch={() => refetchAll}
          />
        </Grid2>
      </Grid2>
      <ClassesRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
      <ClassRegister
        open={openClassRegister}
        onClose={() => setOpenClassRegister(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Classes;
